const customDynamicCdns = {
    CHINA_CTG: 'china_ctg_dynamic',
};

export default customDynamicCdns;
